import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import "../../_components/antd.css";
import { Table } from "antd";
import { onShowSizeChange } from "../../_components/paginationfunction";
import useCustomerHook from "../useCustomerHook";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";

const DocumentView = () => {
  const [menu, setMenu] = useState(false);
  const { uuid } = useParams();
  const { FetchCustomersDocuments } = useCustomerHook();
  const { customersDocuments } = FetchCustomersDocuments(uuid);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const datasource = customersDocuments;

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Uploaded Date",
      dataIndex: "uploaded_at",
      render: (text) => {
        if (!text) return "";
        const date = new Date(text);
        const day = String(date.getDate()).padStart(2, "0");
        const month = moment(date).format("MMM");
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
      },
    },
    {
      title: "Action",
      dataIndex: "Action",
      render: (val, row) => (
        <div className="d-flex">
          <a
            href={row.file}
            rel="noreferrer"
            target="_blank"
            className="btn btn-greys bg-history-light me-2"
          >
            <i className="far fa-eye me-1" /> View
          </a>
          <div
            className="btn btn-greys bg-danger-light me-2"
            onClick={() => {
              if (
                window.confirm("Are you sure you want to delete this document?")
              ) {
                fetch(`/customers/${uuid}/documents?id=${row.id}`, {
                  method: "DELETE",
                  headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": document.cookie
                      .split("; ")
                      .find((row) => row.startsWith("csrftoken="))
                      ?.split("=")[1],
                    credentials: "include",
                  },
                })
                  .then((res) => {
                    if (res.ok) {
                      window.location.reload();
                    } else {
                      alert("Failed to delete document.");
                    }
                  })
                  .catch(() => alert("Failed to delete document."));
              }
            }}
          >
            Delete
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper custom-class-td">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="content-page-header ">
                <h5>Customer Documents</h5>
                <div className="list-btn">
                  <Link
                    to={`/customers/${uuid}/documents/add`}
                    className="btn btn-primary"
                  >
                    Add Document
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className=" card-table">
                  <div className="card-body">
                    <div className="table-responsive table-hover">
                      <Table
                        pagination={{
                          total: datasource?.length || 0,
                          // showTotal: (total, range) =>
                          //   `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          showSizeChanger: true,
                          onShowSizeChange: onShowSizeChange,
                        }}
                        columns={columns}
                        dataSource={datasource}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentView;
